import { useContext, useMemo, useState, SyntheticEvent } from 'react';
import { Location, To, useLocation, useNavigate, useSearchParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import { BottomNavigation, BottomNavigationAction, Box, Container, useMediaQuery } from '@mui/material';

import { ctxUser } from '@/contexts/UserContext';
import { chatContext } from '@/contexts/ChatContext';
import { getAdditionalElements } from '@/popups';
import { PopupType } from '@/types';
import { NavigationIcon } from '@/shared/ui/navigation-icon/NavigationIcon';
import { absolutePopupPath, joinPopupPath } from '@/utilities/popupPath';

import './Home.css';

function containsPath(popups: PopupType[], pathname: string): boolean {
  return popups.some((popup) => {
    const popupPath = absolutePopupPath(popup.path);

    if (pathname === popupPath || pathname.endsWith(popupPath)) return true;
    return popup.children ? containsPath(popup.children, pathname) : false;
  });
}

function getSelectedValue(
  popups: PopupType[],
  more: PopupType[],
  pathname: string,
  fallback: string | undefined
): string | undefined {
  if (containsPath(more, pathname)) {
    const morePopup = popups.find((popup) => popup.navigateTo === 'more' || popup.path === 'more');
    if (morePopup) return morePopup.navigateTo || morePopup.path;
  }

  const popup = popups.find((popup) => pathname.endsWith(popup.path));
  return popup?.path || fallback;
}

export function HomeBottomNav({ popups }: { popups: PopupType[] }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const [value, setValue] = useState<string | undefined>(location.pathname);
  const userCtx = useContext(ctxUser);
  const chatCtx = useContext(chatContext);
  const { t } = useTranslation();

  const more = useMemo(() => getAdditionalElements(async () => {}, true, true), []);
  const selectedValue = getSelectedValue(popups, more, location.pathname, value);

  // a LeftNav is legyen useMemo ???
  const id = useMemo(() => {
    return chatCtx?.chatId;
  }, [chatCtx?.chatId]);

  function hasExtraFeature(popup: PopupType) {
    if (!popup.requiredExtraFeature) return true;
    return userCtx?.hasExtraFeature(popup.requiredExtraFeature);
  }

  const filtered = popups
    .filter((p) => !p.hidden)
    .filter((p) => p.showMobile)
    .filter((p) => hasExtraFeature(p))
    .filter((p) => !userCtx?.isToken() || p.showToken)
    .filter((p) => !p.show || p.show(userCtx?.user, id));

  const narrowScreenSize = useMediaQuery('(max-width: 370px)');

  // sajnos
  function fix(p: string) {
    if (p === 'tracking' || p === 'routes') return p;
    return 'tracking';
  }

  // ez ugyanaz mint a LeftNav-nal
  function getNav(p: PopupType, location: Location) {
    if (p.level === 1) return p.navigateTo || absolutePopupPath(p.path);

    // ha en vagyok az aktiv es a more vagyok :( ez sajnos most be van egetve
    if (p.navigateTo && location.pathname.endsWith(p.navigateTo)) {
      const prev = searchParams.get('prev');
      if (prev?.startsWith('/tracking/select') || prev?.startsWith('/routes/select')) return prev;
      return '/tracking/select'; // return -1;
    }

    // ha en vagyok az aktiv akkor nem csinal semmit
    if (location.pathname.endsWith(p.path)) return location.pathname;

    // nem en vagyok az aktiv
    // mi van ha az elso resz nem a tracking vagy a route ?? ha a reports-rol jon ???
    const parts = location.pathname.split('/'); // regex lehet jobb lenne

    /*
    if (parts.length === 2) {
      // a nulladik elem ures string :(
      const to = '/' + fix(parts[1]) + '/' + p.path;
      //  + '?prev=' + value;
      return to;
    }
    */

    let to = joinPopupPath('/' + fix(parts[1]), p.path);
    if (p.navigateTo) {
      // a more-nak atadjuk, honnan jott
      to = to + '?prev=' + selectedValue + location.search;
    }
    return to;
  }

  async function bottomNavigationOnChange(_event: SyntheticEvent, newValue: string) {
    const p = popups.find((p) => p.navigateTo === newValue || p.path === newValue);
    if (!p) {
      console.error('popup not found: ', newValue);
      return;
    }
    const t = getNav(p, location);
    await navigate(t as To);
    setValue(newValue);
    return;
    /*
    // -1 eseten nem lesz active
    if (t !== -1) setValue(newValue);
    else {
      setTimeout(() => {
        // a sima location nem update-elodik ???
        setValue(window.location.pathname);
        console.log(50, window.location.pathname);
      }, 50);
    }
    */
  }

  return (
    <Box className="home-nav">
      <Container maxWidth={false} className="home-bottom-nav-container">
        <BottomNavigation
          showLabels
          value={selectedValue}
          className="home-bottom-nav-navigator"
          onChange={bottomNavigationOnChange}
        >
          {filtered.map((p) => (
            <BottomNavigationAction
              key={p.title || p.path}
              value={p.navigateTo || p.path}
              label={
                narrowScreenSize ? (
                  ''
                ) : (
                  <span data-qa-element-id={`bottom-navigation-label-${p.title}`}>{t(p.title!)}</span>
                )
              }
              icon={<NavigationIcon popup={p} />}
              data-qa-element-id={`bottom-navigation-action-${p.title}`}
              className="home-bottom-nav-action"
              slotProps={{
                label: {
                  sx: {
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    width: '100%',
                    fontSize: '10px !important',
                  },
                },
                root: { sx: { padding: 1 } },
              }}
              sx={{ letterSpacing: -0.25 }}
            />
          ))}
        </BottomNavigation>
      </Container>
    </Box>
  );
}
